import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider as MobxProvider } from "mobx-react";
import { hot } from "react-hot-loader/root";
import Layout from "./layouts/Layout";
import ErrorBoundary from "./layouts/ErrorBoundary";
import AppRoutes from "./Routes";
import stores from "./stores";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import he from "./translations/he.json";
import en from "./translations/en.json";
import GlobalStyles from "./UI/GlobalStyles";
import { ThemeProvider } from "styled-components";
import theme from "./UI/theme";
import { MobileProvider } from "./utils/mobile";


let REACT_APP_API = window.env.REACT_APP_API;
let YARN_CACHE_FOLDER = window.env.YARN_CACHE_FOLDER;
let NODE_ENV = window.env.NODE_ENV;


console.info("Application starting with the following environment variables:");
console.info("REACT_APP_API:", REACT_APP_API);
console.info("YARN_CACHE_FOLDER:", YARN_CACHE_FOLDER);
console.info("NODE_ENV:", NODE_ENV);


i18next.use(initReactI18next).init({
  resources: {
    he: he,
    en: en,
  },
  fallbackLng: "he",
  lng: "he",
  languages: ["he", "en"],

  interpolation: {
    escapeValue: false,
  },
});

const App = () => {
  useEffect(() => {
    document.title = "Coralis";
  }, []);

  return (
    <MobxProvider {...stores}>
      <GlobalStyles />
      <ErrorBoundary>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <MobileProvider>
              <Layout>
                <AppRoutes />
              </Layout>
            </MobileProvider>
          </ThemeProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </MobxProvider>
  );
};

export default hot(App);
